import { render, staticRenderFns } from "./add-pay-product-modal.vue?vue&type=template&id=4857ff32&scoped=true&"
import script from "./add-pay-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-pay-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-pay-product-modal.vue?vue&type=style&index=0&id=4857ff32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857ff32",
  null
  
)

export default component.exports